import React, { useEffect, useLayoutEffect, useState } from "react";
import OX_Grid from "../OX_Grid";

const DetailComponent = (props) => {
  const { rowTemplate, dataItem, core, appId, columnConfig, actions, actionButtonType, parentRef } = props;

  const restClient = core?.make("oxzion/restClient");
  const loader = core?.make("oxzion/splash");

  const [childData, setChildData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useLayoutEffect(() => {
    const getChild = async () => {
      setIsLoading(true);
      if (dataItem.is_parent) {
        try {
          const response = await restClient.request("v1", `app/${appId}/file/user/me/assoc/${dataItem.uuid}`, {}, "get");
          if (response.status === "success") {
            setChildData(response.data);
          }
        } catch (error) {
          console.error("Error fetching child data:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    getChild();
  }, []);

  useEffect(() => {
    if (isLoading) {
      loader.show(document.getElementById("loader"));
    } else {
      loader.destroy(document.getElementById("loader"));
    }
  }, [isLoading]);

  if (isLoading) {
    return <div id="loader"></div>;
  }

  return rowTemplate ? (
    <div>{rowTemplate(dataItem)}</div>
  ) : (
    childData.length > 0 && (
      <OX_Grid
        actions={actions}
        actionButtonType={actionButtonType}
        dataSource={childData}
        core={core}
        appId={appId}
        columnConfig={columnConfig}
        pageable={false}
        showColumnHeaders={false}
        listOptions={{showHierarchy: true}}
        parentRef={parentRef}
      />
    )
  );
};

export default DetailComponent;
